"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBeforeFreePlanMigrationGracePeriodEnds = isBeforeFreePlanMigrationGracePeriodEnds;
exports.contextIsInMigrationGracePeriodFromLegacyPlanEpoch = contextIsInMigrationGracePeriodFromLegacyPlanEpoch;
exports.contextIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch = contextIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch;
exports.metadataIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch = metadataIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch;
exports.contextWasMigratedFromLegacyPlanEpoch = contextWasMigratedFromLegacyPlanEpoch;
exports.metadataWasMigratedFromLegacyPlanEpoch = metadataWasMigratedFromLegacyPlanEpoch;
exports.daysUntilMigrationGracePeriodForLegacyFreeUsersEnds = daysUntilMigrationGracePeriodForLegacyFreeUsersEnds;
exports.getFreePlanAnnouncementKey = getFreePlanAnnouncementKey;
const models_1 = require("@buildwithflux/models");
/**
 * This is:
 *   11:59:59 PM on April 15, 2025 PDT
 */
const FreePlanMigrationGracePeriodEnd = new Date("2025-04-16T06:59:59Z");
/**
 * This is:
 *   11:59:59 PM on April 30, 2025 PDT
 */
const FreePlanMigrationPromotionalGracePeriodEnd = new Date("2025-05-01T06:59:59Z");
function isBeforeFreePlanMigrationGracePeriodEnds({ date = new Date(), promotional = false, } = {}) {
    return date <= (promotional ? FreePlanMigrationPromotionalGracePeriodEnd : FreePlanMigrationGracePeriodEnd);
}
function contextIsInMigrationGracePeriodFromLegacyPlanEpoch(context) {
    return contextWasMigratedFromLegacyPlanEpoch(context) && isBeforeFreePlanMigrationGracePeriodEnds();
}
function contextIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch(context) {
    return (contextWasMigratedFromLegacyPlanEpoch(context) && isBeforeFreePlanMigrationGracePeriodEnds({ promotional: true }));
}
function metadataIsInMigrationPromotionalGracePeriodFromLegacyPlanEpoch(currentUserPrivateMetadata) {
    return (metadataWasMigratedFromLegacyPlanEpoch(currentUserPrivateMetadata) &&
        isBeforeFreePlanMigrationGracePeriodEnds({ promotional: true }));
}
function contextWasMigratedFromLegacyPlanEpoch(context) {
    return context.type === "user" && metadataWasMigratedFromLegacyPlanEpoch(context.currentUserPrivateMetadata);
}
function metadataWasMigratedFromLegacyPlanEpoch(currentUserPrivateMetadata) {
    return (currentUserPrivateMetadata.creationFlags?.migratedFromPlanEpoch === models_1.PlanEpoch.enum.legacy &&
        currentUserPrivateMetadata.creationFlags?.planEpoch === models_1.PlanEpoch.enum.from_202410);
}
function daysUntilMigrationGracePeriodForLegacyFreeUsersEnds() {
    return Math.max(0, Math.ceil((FreePlanMigrationGracePeriodEnd.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
}
function getFreePlanAnnouncementKey() {
    return isBeforeFreePlanMigrationGracePeriodEnds()
        ? models_1.FreePlanAnnouncementKey.enum.freePlan
        : models_1.FreePlanAnnouncementKey.enum.freePlanAfterDisabled;
}
//# sourceMappingURL=migration.js.map